define('Store.ProductDetailsPage.EntryPoint', [
    'Store.ProductDetails.QuantityPricing.View',
    'Backbone'
], function StoreProductDetailsPageEntryPoint(
    QuantityPricingView,
    Backbone
) {
    'use strict';

    function unmountOldQuantityPricingView(application) {
        var layout = application.getComponent('Layout');
        layout.addChildViews('Backbone.View', {
            'Quantity.Pricing': {
                'Quantity.Pricing': {
                    childViewIndex: 1,
                    childViewConstructor: function childViewConstructor() {
                        var EmptyView = Backbone.View.extend({ template: function template() { return ''; } });
                        return new EmptyView();
                    }
                }
            }
        });
    }

    function mountQuantityPricing(application) {
        var layout = application.getComponent('Layout');
        var pdp = application.getComponent('PDP');
        layout.addChildViews('ProductDetails.Full.View', {
            'Quantity.Pricing': {
                'Store.Quantity.Pricing': {
                    childViewIndex: 1,
                    childViewConstructor: function childViewConstructor() {
                        return new QuantityPricingView({
                            pdpComponent: pdp,
                            application: application
                        });
                    }
                }
            }
        });

        pdp.on('afterShowContent', function onBeforeShowContent() {
            var view = application.getLayout().getCurrentView();
            var itemInfo = pdp.getItemInfo();
            // eslint-disable-next-line no-underscore-dangle
            var ispurchasable = itemInfo.item.keyMapping_isPurchasable;

            if (ispurchasable === false) {
                view.$('[data-view="Quantity"]').html('<div></div>');
                view.$('[data-view="Quantity.Pricing"]').html('<div></div>');
                view.$('.product-views-price').remove();
            }
        });
    }

    return {
        mountToApp: function mountToApp(application) {
            unmountOldQuantityPricingView(application);
            mountQuantityPricing(application);
        }
    };
});
